import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MainContent from './components/MainContent';

export default function Blog(props: { disableCustomTheme?: boolean }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    // <MainContent />
    <h1>Coming Soon</h1>
  );
}
